function allSettled(arrayOrPromise) {
  return Promise.resolve(arrayOrPromise).then(promises => Promise.all(promises.map(promise => Promise.resolve(promise).then(value => ({
    status: 'fulfilled',
    value
  })).catch(reason => ({
    status: 'rejected',
    reason
  })))));
}
export default allSettled;